// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__q4jFy","icon":"styles_icon__e3_sQ"};